export default "__VITE_ASSET__DbHuRqs8__"